export default {

    createData() {
        return [{
            x: new Date(2018, 0, 1),
            y: 10
        }, {
            x: new Date(2018, 2, 1),
            y: 2
        }]
    },
    getOptionsTime(
        title = 'graph title',
        yLabel = 'valuer du y',
        timeFormat = 'YYYY-MM-DD',
        tooltipFormat = 'll HH:mm'
    ) {
        return {
            title: {
                text: title
            },
            scales: {
                xAxes: [{
                    type: "time",
                    time: {
                        parser: timeFormat,
                        tooltipFormat: tooltipFormat
                    },
                    scaleLabel: {
                        display: false,
                        labelString: 'Date'
                    }
                },],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: yLabel + ' ' + 'value'
                    }
                }]
            }
        }
    }
}